import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaRegEdit } from "react-icons/fa";
import { Icon } from "organisms/iconCommonent";

interface ContentData {
  _id: string;
  heading: string;
  description?: string;
  __v?: number;
}

export default function Catalyse() {
  const [content, setContent] = useState<ContentData | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [heading, setHeading] = useState("");
  const [description, setDescription] = useState("");


  const apiUrl = `${process.env.REACT_APP_LOCAL_URL}/api/content/68efe37a2d25c3fab303211a`;

  const fetchContent = async () => {
    try {
      const res = await axios.get(apiUrl);
      if (res.data.status === "success") {
        const data = res.data.data;
        setContent(data);
        setHeading(data.heading);
        setDescription(data.description || "");
      }
    } catch (error) {
      console.error("Error fetching content:", error);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content) return;

    try {
      await axios.patch(apiUrl, { heading, description });
      await fetchContent();
      setShowModal(false);
    
    } catch (error) {
      console.error("Error updating content:", error);
     
    }
  };

  return (
    <div className="p-4 ">
      <h2 className="font-lato-regular">Section - 03</h2>
      {content && (
        <div className="bg-white p-6  w-full border border-gray-200 rounded-xl overflow-hidden relative">
          <h3
            className="text-xl font-semibold mb-2 font-lato-semibold"
            dangerouslySetInnerHTML={{ __html: content.heading }}
          />
          <div
            className="text-gray-700 mb-4 font-lato-regular"
            dangerouslySetInnerHTML={{ __html: content.description || "" }}
          />

          <button
            onClick={() => setShowModal(true)}
            className="bg-blue-500 text-white px-2 py-1 rounded flex gap-2 justify-center items-center"
          >
            <Icon icon={FaRegEdit} />
            <span>Edit</span>
          </button>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Background overlay */}
          <div
            className="absolute inset-0 bg-black opacity-40"
            onClick={() => setShowModal(false)}
          />

          {/* Modal content */}
          <div className="bg-white p-6 rounded-lg shadow-lg z-10 w-full max-w-lg relative">
            <h2 className="text-lg font-bold mb-4">Edit Content</h2>
            <form onSubmit={handleUpdate} className="space-y-4">
              <div>
                <label className="block font-semibold mb-1">Heading</label>
                <input
                  type="text"
                  value={heading}
                  onChange={(e) => setHeading(e.target.value)}
                  required
                  className="w-full border border-gray-300 rounded p-2"
                />
              </div>

              <div>
                <label className="block font-semibold mb-1">Description</label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={6}
                  className="w-full border border-gray-300 rounded p-2"
                />
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Update
                </button>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="text-red-500 border border-red-500 px-4 py-2 rounded-md hover:bg-red-50"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
